import { SET_LOBBY } from '../actions/lobby.actions';
const initalState = {
  lobby: null,
  connectedUsers: null,
  kicked: false,
  gameStepsByUser: null
};
export default (state = initalState, action) => {
  const {
    payload
  } = action;
  switch (action.type) {
    case SET_LOBBY:
      {
        const {
          lobby,
          connectedUsers,
          disconnectedUsers,
          kicked,
          gameStepsByUser,
          hostBack
        } = payload;
        if (kicked) {
          return {
            ...state,
            kicked
          };
        }
        if (!state.lobby || lobby?._id && state.lobby._id !== lobby._id) {
          return {
            ...payload
          };
        }
        return {
          lobby: {
            ...state.lobby,
            ...lobby
          },
          connectedUsers: connectedUsers || state.connectedUsers,
          disconnectedUsers: disconnectedUsers || state.disconnectedUsers,
          gameStepsByUser: {
            ...state.gameStepsByUser,
            ...gameStepsByUser
          },
          kicked: state.kicked,
          // { from: <host's name> }: this player lost host by disconnecting and may take it back (LobbyRecoveryBar).
          hostBack: hostBack !== undefined ? hostBack : state.hostBack
        };
      }
    default:
      return state;
  }
};